module.exports = __webpack_public_path__ + "img/green_129.eb1f0915.png";